import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddContact = (props) => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(
    props.mode === "edit" ? props.contact.content : ""
  );

  const [edit, setEdit] = useState(props.mode === "edit" ? false : true);

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const validate = () => {
    if (!content) {
      return false;
    } else {
      return true;
    }
  };

  const fetchEditLead = async (id, field, value) => {
    var body = { id: id, field: field, value: value };

    await fetch("https://apisellcrm.ftpeople.pl/editLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        props.close();
      })
      .catch((error) => {});
  };

  const fetchAddContact = async () => {
    var body = {
      content: content,
      user: props.user.id,
      id: props.mode === "list" ? props.leadId : props.lead.id,
    };

    await fetch("https://apisellcrm.ftpeople.pl/addContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Kontakt",
          text: "dodany",
        }).then(async (result) => {
          if (props.mode === "list") {
            var id = props.leadId;
            var field = "lastTalkDate";

            var date =
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1) +
              "-" +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate());

            fetchEditLead(id, field, date);
          } else {
            props.close();
          }
        });
      })
      .catch((error) => {});
  };

  const addContact = () => {
    if (validate()) {
      fetchAddContact();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const fetchEditContact = async () => {
    var body = { id: props.contact.id, content: content };

    await fetch("https://apisellcrm.ftpeople.pl/editContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Kontakt",
          text: "zmieniony",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const editContact = () => {
    if (validate()) {
      fetchEditContact();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const fetchDeleteContact = async () => {
    var body = { id: props.contact.id };

    await fetch("https://apisellcrm.ftpeople.pl/deleteContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Kontakt",
          text: "usunięty",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const deleteContact = (e) => {
    fetchDeleteContact();
  };

  const endEditMode = (e) => {
    setEdit(false);
    setContent(props.contact.content);
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "2",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                {edit ? (props.mode === "edit" ? "EDYTUJ" : "DODAJ") : ""}{" "}
                KONTAKT
                <br />
                <span style={{ fontSize: ".8vw" }}>
                  Użytkownik: {props.user.name}
                </span>
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>

            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "99%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  notatka
                </p>
                <textarea
                  type="text"
                  style={{
                    width: "100%",
                    padding: "10px 10px",
                    boxSizing: "border-box",
                    height: "10vh",
                    resize: "none",
                  }}
                  disabled={!edit}
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                gap: "20px",
              }}
            >
              {edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                    onClick={props.mode === "edit" ? editContact : addContact}
                  >
                    {props.mode === "edit" ? "EDYTUJ" : "DODAJ"} KONTAKT
                  </button>
                </>
              ) : (
                ""
              )}
              {props.mode === "edit" &&
              !edit &&
              (+props.contact.user === +props.user.id ||
                props.user.role === "admin") ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "navy",
                      borderColor: "navy",
                    }}
                    onClick={() => setEdit(true)}
                  >
                    TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" &&
              edit &&
              (+props.contact.user === +props.user.id ||
                props.user.role === "admin") ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={endEditMode}
                  >
                    ZAKOŃCZ TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" &&
              (+props.contact.user === +props.user.id ||
                props.user.role === "admin") ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={deleteContact}
                  >
                    USUŃ
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddContact;
